import React from "react";

const TvMovies = () => <p>TV {"&"} Shows</p>;

export default TvMovies;
